import React from 'react';

import { createColumnHelper } from '@tanstack/react-table';

import { EntitlementsProject } from '@adsk/alloy-provider';

import { AccountNameCell } from './AccountNameCell';
import { CreatedAtCell } from './CreatedAtCell';
import { NameCell } from './NameCell';
import { NumberCell } from './NumberCell';
import { ProductEntryFlowCell } from './ProductEntryFlowCell';
import { TypeCell } from './TypeCell';
import i18n from '../../../helpers/i18n';

const columnHelper = createColumnHelper<EntitlementsProject>();

export const platformColumn = columnHelper.accessor('platform', {
  id: 'platform',
  header: () => i18n.t('TYPE'),
  cell: (props) => <TypeCell {...props} />,
  size: 10,
  minSize: 50,
  sortDescFirst: false,
});

export const nameColumn = columnHelper.accessor('name', {
  id: 'name',
  header: () => i18n.t('NAME'),
  cell: (props) => <NameCell {...props} />,
  minSize: 250,
  sortDescFirst: false,
});

export const jobNumberColumn = columnHelper.accessor('jobNumber', {
  id: 'jobNumber',
  header: () => i18n.t('NUMBER'),
  cell: (props) => <NumberCell {...props} />,
  sortDescFirst: false,
});

export const productEntryFlowCellColumn = columnHelper.accessor('products', {
  id: 'products',
  header: () => i18n.t('DEFAULT_PRODUCT'),
  cell: (props) => <ProductEntryFlowCell {...props} />,
  enableSorting: false,
  minSize: 205,
});

export const defaultAccessCellColumn = columnHelper.accessor('products', {
  id: 'products',
  header: () => i18n.t('DEFAULT_ACCESS'),
  cell: (props) => <ProductEntryFlowCell {...props} />,
  enableSorting: false,
  minSize: 205,
});

export const accountNameCellColumn = columnHelper.accessor('accountName', {
  id: 'accountName',
  header: () => i18n.t('ACCOUNT_NAME'),
  cell: (props) => <AccountNameCell {...props} />,
  sortDescFirst: false,
});

export const createdAtCellColumn = columnHelper.accessor('createdAt', {
  id: 'createdAt',
  header: () => i18n.t('CREATED_ON'),
  cell: (props) => <CreatedAtCell {...props} />,
  size: 100,
  sortDescFirst: false,
});
